import { create } from 'zustand'

export type AuthMode = 'local' | 'oidc' | null

export interface AuthUser {
  id: number
  username: string
  displayName: string | null
  role: string
}

interface AuthState {
  /** Access token lives in memory only — never localStorage */
  accessToken: string | null
  user: AuthUser | null
  authMode: AuthMode
  isLoading: boolean

  setAccessToken: (token: string | null) => void
  setUser: (user: AuthUser | null) => void
  setAuthMode: (mode: AuthMode) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  authMode: null,
  isLoading: true,

  setAccessToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  setAuthMode: (authMode) => set({ authMode }),
  setLoading: (isLoading) => set({ isLoading }),

  logout: () =>
    set({
      accessToken: null,
      user: null,
    }),
}))
